_getSearchAutocomplete